/*
 * This file is part of glowingblue/orell-rezensionen.
 *
 * Copyright (c) 2021 Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import { components } from '@glowingblue-orell-thalia-common';
import type User from 'flarum/common/models/User';

const { PostActivityLeaderItem } = components;

export default class ReviewsActivityLeaderItem extends PostActivityLeaderItem {
	get value(): number {
		// `PostActivityLeaderItem` is typed `Component<any>` upstream, so narrow its attrs here.
		const { user } = this.attrs as { user: User };
		return user.recentReviewsCount();
	}

	get icon(): string {
		return 'far fa-book-heart';
	}
}
